// Utility functions for handling URL parameters related to schedule sharing

export const encodeScheduleParams = (
  startTime,
  temperature,
  customDurations,
  direction
) => {
  const params = new URLSearchParams();
  params.set("startTime", startTime.toISOString());
  params.set("temp", temperature.toString());
  params.set("direction", direction || "forward");

  if (Object.keys(customDurations).length > 0) {
    params.set("durations", JSON.stringify(customDurations));
  }

  return params.toString();
};

export const decodeScheduleParams = (search) => {
  const params = new URLSearchParams(search);

  const startTime = params.get("startTime");
  const temperature = params.get("temp");
  const direction = params.get("direction");
  const durations = params.get("durations");

  if (!startTime || !temperature) {
    return null;
  }

  return {
    timeInput: {
      time: new Date(startTime),
      direction: direction || "forward",
    },
    temperature: parseInt(temperature, 10),
    customDurations: durations ? JSON.parse(durations) : {},
  };
};

export const generateShareableUrl = (
  startTime,
  temperature,
  customDurations,
  direction
) => {
  const baseUrl = window.location.origin + window.location.pathname;
  const params = encodeScheduleParams(
    startTime,
    temperature,
    customDurations,
    direction
  );
  return `${baseUrl}?${params}`;
};
